import MobilePanel from "./MobilePanel"

export default MobilePanel